"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manActionsCreator = void 0;
const ManipulationTypes_1 = require("./ManipulationTypes");
const manActionsCreator = (prefix) => ({
    changePagination(pagination) {
        return {
            type: `${prefix}_${ManipulationTypes_1.PAGINATION_CHANGE}`,
            payload: pagination,
        };
    },
    changeFilter(filter) {
        return {
            type: `${prefix}_${ManipulationTypes_1.FILTER_CHANGE}`,
            payload: filter,
        };
    },
    changeSort(sort) {
        return {
            type: `${prefix}_${ManipulationTypes_1.SORT_CHANGE}`,
            payload: sort,
        };
    },
    changeSearch(search) {
        return {
            type: `${prefix}_${ManipulationTypes_1.SEARCH_CHANGE}`,
            payload: search,
        };
    },
});
exports.manActionsCreator = manActionsCreator;
//# sourceMappingURL=ManipulationActions.js.map